export const config = {
  hosts: {
    domain: null,
    muc: null,
    focus: null,
  },
  disableSimulcast: false,
  constraints: {
    video: {
      height: {
        ideal: 1080,
        max: 1080,
        min: 180,
      },
      width: {
        ideal: 1920,
        max: 1920,
        min: 360,
      },
    },
  },
  enableP2P: false, // flag to control P2P connections
  p2p: {
    enabled: false,
    enableUnifiedOnChrome: true,
    disableH264: true,
    useStunTurn: true, // use XEP-0215 to fetch STUN and TURN servers for the P2P connection
  },
  useStunTurn: true, // use XEP-0215 to fetch TURN servers for the JVB connection
  useTurnUdp: false,
  bosh: null, // FIXME: use xep-0156 for that
  websocket: null, // FIXME: use xep-0156 for that
  websocketKeepAliveUrl: null,
  clientNode: null, // The name of client node advertised in XEP-0115 'c' stanza
  desktopSharingSources: ['screen', 'window'],
  desktopSharingChromeSources: ['screen', 'window', 'tab'],
  enableLipSync: false,
  enableSaveLogs: false,
  disableRtx: false, // Enables RTX everywhere
  enableScreenshotCapture: false,
  channelLastN: 25, // The default value of the channel attribute last-n.
  videoQuality: {
    preferredCodec: "VP9",
    codecPreferenceOrder: ["VP9", "VP8", "H264", "AV1"],
    enableAdaptiveMode: false,
    vp9: {
      maxBitratesVideo: {
        low: 100000,
        standard: 300000,
        high: 1200000,
        fullHd: 2500000,
        ultraHd: 5000000,
        ssHigh: 2500000
      },
      scalabilityModeEnabled: false,
      useSimulcast: false,
      useKSVC: true
    },
  },
  useNewBandwidthAllocationStrategy: true,
  startBitrate: '800',
  disableAudioLevels: false,
  stereo: false,
  forceJVB121Ratio: -1,
  enableTalkWhileMuted: true,
  mouseMoveCallbackInterval: 1000,
  enableNoAudioDetection: true,
  enableNoisyMicDetection: true,
  disableLocalVideoFlip: false,
  hiddenDomain: null,
  enableUserRolesBasedOnToken: false,
  enableLayerSuspension: true,
  enableUnifiedOnChrome: true,
  enableWelcomePage: true,
  enableInsecureRoomNameWarning: false,
  e2eping: {
    pingInterval: -1,
  },
  abTesting: {},

  // flags: {
  //   sourceNameSignaling: true,
  //   sendMultipleVideoStreams: true,
  //   receiveMultipleVideoStreams: true,
  //   ssrcRewritingEnabled: false,
  // },
  resolution: 720,
  maxFullResolutionParticipants: 50,
  desktopSharingFrameRate: {
    min: 30,
    max: 30,
  },

  hideDominantSpeakerBadge: true,
  firefox_fake_device: true,
  makeJsonParserHappy: 'even if last key had a trailing comma',
  flags: {
    sourceNameSignaling: true,
    sendMultipleVideoStreams: true,
    receiveMultipleVideoStreams: true
  },
  bridgeChannel: {
    preferSctp: true
  },
  deploymentInfo: {
    environment: 'meetn',
    region: 'us',
    userRegion: 'us',
  },
};

/* eslint-enable no-unused-vars, no-var */
